import { render, staticRenderFns } from "./mySetting.vue?vue&type=template&id=ddeebfc8&scoped=true"
import script from "./mySetting.vue?vue&type=script&lang=js"
export * from "./mySetting.vue?vue&type=script&lang=js"
import style0 from "./mySetting.vue?vue&type=style&index=0&id=ddeebfc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddeebfc8",
  null
  
)

export default component.exports